<template>
  <Modal title="新增账号" v-model="visible" width="700" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <Form ref="form" :model="formData" class="page-form less" :label-width="75">
      <FormItem prop="indoorStaffId" label="内勤人员">
        <Select v-model="formData.indoorStaffId" filterable transfer clearable @on-change="changeIndoorStaffId">
          <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem prop="buzOrganId" label="所属机构" :rules="$units.formRule.required('请输入')">
        <selectTree
          ref="selectRef"
          v-model="formData.buzOrganId"
          :multiple="false"
          type="4"
          @change="changeOrg"
          :disabled="!!formData.indoorStaffId"
        ></selectTree>
      </FormItem>

      <FormItem prop="userName" label="登录用户" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.userName" clearable :maxlength="11" placeholder="请输入登录用户" :disabled="!!formData.indoorStaffId" />
      </FormItem>

      <FormItem prop="account" label="登录账号" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.account" clearable placeholder="请输入账号" />
      </FormItem>

      <FormItem
        prop="password"
        label="登录密码"
        :rules="[$units.formRule.required('请输入'), { validator: validatePassCheck, trigger: 'blur', required: true }]"
      >
        <Input type="password" password v-model="formData.password" placeholder="请输入密码" />
        <div class="info-text">密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种</div>
      </FormItem>

      <FormItem prop="roleIds" label="角色" :rules="$units.formRule.arrRequired('请输入')" class="full">
        <Select v-model="formData.roleIds" clearable filterable transfer style="width: 92%" :multiple="true" @on-open-change="queryRoleList()">
          <Option :value="item.id" v-for="(item, index) in roleLsit" :key="index">{{ item.name }}</Option>
        </Select>
        <a class="text" @click="addRole">新增</a>
      </FormItem>

      <FormItem prop="mobile3" label="手机号" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.mobile3" clearable :maxlength="11" placeholder="请输入手机号" />
      </FormItem>

      <FormItem prop="dataType" :rules="$units.formRule.required('请选择')" label :label-width="100">
        <span slot="label" class="label">
          数据权限<span class="tip-icon">?</span>
          <div class="pop-tip">
            <span>本级机构及下级机构：支持查看当前及所有下级机构数据</span><br />
            <span>单独配置：自行配置此账号查看的数据范围，不可查看未勾选机构的数据</span>
            <div class="arrow"></div>
          </div>
        </span>
        <RadioGroup v-model="formData.dataType" style="margin-top: -1px" @on-change="changeOrgSetUp">
          <Radio label="1">本机构及下级机构</Radio>
          <Radio label="2">单独设置</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem prop="dataOrgIds" label="" :rules="$units.formRule.arrRequired('请选择数据权限')" class="full" v-if="formData.dataType == '2'">
        <selectTree
          v-model="formData.dataOrgIds"
          :multiple="true"
          :maxTagCount="5"
          type="4"
          ref="selectTreeRef"
          :orgId="formData.buzOrganId"
          @treeClick="treeClick"
          :checkChild="false"
          @getTreeData="getTreeData"
          :showCloseIcon="false"
        ></selectTree>
      </FormItem>

      <FormItem prop="supervise" :rules="$units.formRule.required('请选择')" label="简洁模式" :label-width="100" v-if="$units.superviseShowVal()">
        <span slot="label" class="label-mode">
          简洁模式<span class="tip-icon">?</span>
          <div class="pop-tip">
            <span>简洁模式为监管模式，开启后您不能主动退出，非监管数据将会隐藏</span>
            <div class="arrow"></div>
          </div>
        </span>
        <RadioGroup v-model="formData.supervise" style="margin-top: -1px">
          <Radio label="0">否</Radio>
          <Radio label="1">是</Radio>
        </RadioGroup>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="save" v-preventReClick>确认</Button>
    </div>
  </Modal>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: {
    selectTree
  },
  props: ['initList'],
  data() {
    return {
      visible: false,
      formData: {
        indoorStaffId: '',
        userName: '',
        password: '',
        roleIds: [],
        account: '',
        buzOrganId: '',
        mobile3: '',
        dataType: '1',
        dataOrgIds: [],
        supervise: '0'
      },
      roleLsit: [],
      treeData: [], //单独设置机构树
      userList: []
    };
  },
  activated() {
    this.queryRoleList();
  },
  methods: {
    validatePassCheck(rule, value, callback) {
      const capital = /[A-Z]/;
      const regLetter = /[a-z]/;
      const regNum = /[0-9]/;
      const regTeShu = new RegExp("[`_~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");

      let complex = 0;
      if (capital.test(value)) {
        ++complex;
      }
      if (regLetter.test(value)) {
        ++complex;
      }
      if (regNum.test(value)) {
        ++complex;
      }
      if (regTeShu.test(value)) {
        ++complex;
      }
      if (complex < 3 || value.length < 8 || value.length > 16) {
        callback(new Error('密码不符规范，请修改'));
      } else {
        return callback();
      }
    },
    changeIndoorStaffId() {
      this.$refs.selectRef && this.$refs.selectRef.openChange(true);
      if (this.formData.indoorStaffId) {
        this.userList.forEach(item => {
          if (item.id == this.formData.indoorStaffId) {
            this.formData.buzOrganId = item.organizationId;
            this.formData.userName = item.name;
            this.formData.mobile3 = item.mobile;
          }
        });
      } else {
        this.formData.buzOrganId = '';
        this.formData.userName = '';
        this.formData.mobile3 = '';
      }
    },
    getUserList() {
      this.$http({
        type: 'POST',
        url: '/buz/userBase/getByOrgIds',
        data: {
          type: 2
        }
      }).then(res => {
        this.userList = res.data;
      });
    },
    save() {
      this.$refs.form.validate().then(isok => {
        if (!this.verification(this.formData.password)) {
          return;
        }
        if (!isok) {
          return;
        }
        const formData = {
          indoorStaffId: this.formData.indoorStaffId,
          account: this.formData.account,
          password: this.formData.password,
          roleIds: this.formData.roleIds,
          buzOrganId: this.formData.buzOrganId,
          mobile3: this.formData.mobile3,
          userName: this.formData.userName,
          dataType: this.formData.dataType,
          dataOrgIds: this.formData.dataType == '1' ? this.formData.buzOrganId : this.formData.dataOrgIds.join(',')
        };
        if (this.formData.supervise == '1') {
          this.$notice
            .inquiry('开启简洁模式后，非监管数据隐藏，开启后本账号无法退出，需要其他账号协助退出，请确认是否开启?')
            .then(async () => {
              formData.supervise = '1';
              this.saveAjax(formData);
            })
            .catch(() => {
              formData.supervise = '0';
              this.saveAjax(formData);
            });
        } else {
          this.saveAjax(formData);
        }
      });
    },
    saveAjax(formData) {
      this.$http({
        url: '/buz/usersExt/add',
        type: 'POST',
        data: formData,
        apiPermissionCode: 'org_10_2'
      }).then(res => {
        this.visible = false;
        this.$notice.success('新增成功');
        this.initList();
      });
    },
    open(data) {
      this.visible = true;
      this.roleLsit = [];
      this.getUserList();
      this.$refs.form && this.$refs.form.resetFields();
    },

    getTreeData(treeData) {
      this.treeData = treeData;
      this.$nextTick(() => {
        // this.$set(treeData[0],'disabled',true);
        // this.$set(treeData[0],'checked',true);
        this.deepCheck(treeData);
        this.$refs.selectTreeRef.setSelectIdByChecked();
      });
    },
    deepCheck(treeData) {
      treeData.forEach(item => {
        item.checked = true;
        if (item.children.length) {
          this.deepCheck(item.children);
        }
      });
    },
    // 权限勾选
    treeClick(data) {
      if (data.checked) {
        if (this.treeData[0].id != data.id) {
          //当前节点不是顶级的直接子级
          this.findTreeParent(this.treeData, data.parentId);
        }
        this.findTreeList([data], true); //勾选子级
      } else {
        this.findTreeList([data], false); //去掉子级勾选
      }
      this.$refs.selectTreeRef.setSelectIdByChecked();
    },
    findTreeParent(tree, id) {
      tree.find(item => {
        if (item.id == id) {
          this.$set(item, 'checked', true);
          if (!item.isTop) {
            //存在非顶级继续查找
            return this.findTreeParent(this.treeData, item.parentId);
          } else {
            return true;
          }
        }
        if (item.children && item.children.length) {
          return this.findTreeParent(item.children, id);
        }
        return false;
      });
    },
    findTreeList(tree, checked) {
      tree.forEach(item => {
        this.$set(item, 'checked', checked);
        if (item.children && item.children.length) {
          this.findTreeList(item.children, checked);
        }
      });
    },

    // 选择所属机构
    changeOrg(data) {
      this.formData.roleIds = [];
      this.roleLsit = [];
      if (data.id) {
        this.queryRoleList();
      }
      this.formData.dataOrgIds = [data.id];
      this.$nextTick(() => {
        this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange(true);
      });
    },

    // 获取角色列表
    queryRoleList() {
      if (!this.formData.buzOrganId) return;
      this.$http({
        url: '/buz/rolesExt/listRoles',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999,
          organizationId: this.formData.buzOrganId
        }
      }).then(res => {
        this.roleLsit = res.data;
      });
    },
    verification(password) {
      const capital = /[A-Z]/;
      const regLetter = /[a-z]/;
      const regNum = /[0-9]/;
      const regTeShu = new RegExp("[`_~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");

      let complex = 0;
      if (capital.test(password)) {
        ++complex;
      }
      if (regLetter.test(password)) {
        ++complex;
      }
      if (regNum.test(password)) {
        ++complex;
      }
      if (regTeShu.test(password)) {
        ++complex;
      }
      if (complex < 3 || password.length < 8 || password.length > 16) {
        this.$notice.error('密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种'); //iview中的一个提示框
        return false;
      } else {
        return true;
      }
    },
    addRole() {
      this.$router.push({
        path: '/systemSet/roleManageAdd',
        query: {
          t: new Date().getTime(),
          backUrl: this.delQueStr(this.$route.fullPath, 'time')
        }
      });
    },
    // 选择数据权限
    changeOrgSetUp(value) {
      // 本机构
      if (value == 2 && this.formData.buzOrganId) {
        this.$nextTick(() => {
          this.$refs.selectTreeRef.openChange(true);
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.my-modal {
  .page-form {
    padding-bottom: 35px;
  }
  .text {
    font-size: 13px;
    float: right;
  }

  .info-text {
    font-size: 12px;
    color: #a8adb7;
    line-height: 1.5;
    padding-top: 7px;
  }

  .label {
    position: relative;
    .tip-icon {
      margin-left: 6px;
      width: 15px;
      height: 15px;
      border-radius: 15px;
      background: transparent;
      border: 1px solid #ccc;
      color: #ccc;
      display: inline-block;
      text-align: center;
      line-height: 14px;
      font-size: 14px;
      cursor: pointer;
      top: 50%;
    }
    .tip-icon:hover + .pop-tip {
      opacity: 0.9;
      z-index: 1;
      display: block;
    }
    .pop-tip {
      position: absolute;
      width: 440px;
      top: 22px;
      display: flex;
      align-items: center;
      text-align: left;
      left: 50%;
      margin-left: -240px;
      padding: 9px 10px;
      display: flex;
      flex-direction: column;
      background-color: #444444;
      display: none;
      border-radius: 4px;
      span {
        font-size: 12px;
        font-weight: 500;
        color: #fff;
      }
      .arrow {
        position: absolute;
        width: 12px;
        height: 12px;
        background-color: #444444;
        opacity: 0.9;
        top: -4px;
        left: 50%;
        margin-left: 45px;
        transform: rotateZ(135deg);
      }
    }
  }
  .label-mode {
    position: relative;
    .tip-icon {
      margin-left: 6px;
      width: 15px;
      height: 15px;
      border-radius: 15px;
      background: transparent;
      border: 1px solid #ccc;
      color: #ccc;
      display: inline-block;
      text-align: center;
      line-height: 14px;
      font-size: 14px;
      cursor: pointer;
      top: 50%;
    }
    .tip-icon:hover + .pop-tip {
      opacity: 0.9;
      z-index: 1;
      display: block;
    }
    .pop-tip {
      position: absolute;
      width: 380px;
      top: 22px;
      display: flex;
      align-items: center;
      text-align: left;
      left: 50%;
      margin-left: 0px;
      padding: 9px 10px;
      display: flex;
      flex-direction: column;
      background-color: #444444;
      display: none;
      border-radius: 4px;
      span {
        font-size: 12px;
        font-weight: 500;
        color: #fff;
      }
      .arrow {
        position: absolute;
        width: 12px;
        height: 12px;
        background-color: #444444;
        opacity: 0.9;
        top: -4px;
        left: 25px;
        transform: rotateZ(135deg);
      }
    }
  }
}
</style>
